import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const toUtcIso = <T>(value: T): T | string => {
  if (value === null || value === undefined || value === '') return value;
  const d = dayjs.utc(value as Parameters<typeof dayjs.utc>[0]);
  return d.isValid() ? d.toISOString() : value;
};
